// extracted by mini-css-extract-plugin
export default {"phoneBox":"ModalHelp_phoneBox__tac8D","phoneNumber":"ModalHelp_phoneNumber__o7dLD","buttons":"ModalHelp_buttons__nYcTn"};